/**
 * Access-request shapes (DB-based RBAC — ADR-0015).
 *
 * A verified Entra user with no active row requests a role + justification; a
 * supervisor/admin approves (granting a role) or denies. Entra is authn only.
 */
import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';
import { RoleSchema } from './enums.js';
/** Access status as the SPA sees it — includes 'none' (no users row yet). */
export const AccessStatusSchema = z.enum(['none', 'pending', 'active', 'denied']);
/** Body for POST /access-requests. */
export const AccessRequestCreateSchema = z.object({
    requested_role: RoleSchema,
    justification: z.string().max(2000).optional(),
});
/** The caller's own access state (GET /access-requests/me + mutation responses). */
export const MyAccessSchema = z.object({
    status: AccessStatusSchema,
    email: z.string(),
    display_name: z.string(),
    role: RoleSchema.nullable(),
    requested_role: RoleSchema.nullable(),
    justification: z.string().nullable(),
    decided_at: IsoDateTimeSchema.nullable(),
});
/** One row in the admin access-request queue. */
export const AccessRequestItemSchema = z.object({
    id: UuidSchema,
    email: z.string(),
    display_name: z.string(),
    status: z.enum(['pending', 'active', 'denied']),
    role: RoleSchema,
    requested_role: RoleSchema.nullable(),
    justification: z.string().nullable(),
    decided_at: IsoDateTimeSchema.nullable(),
    created_at: IsoDateTimeSchema,
});
export const AccessRequestListResponseSchema = z.object({
    data: z.array(AccessRequestItemSchema),
});
/** Admin approve body. The granted role is an explicit decision, never a
 *  default — otherwise a plausible-looking request for 'admin' is one click
 *  from being granted verbatim. The admin UI always sends one. */
export const AccessDecisionSchema = z.object({
    role: RoleSchema,
});
//# sourceMappingURL=access.js.map